import React from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import Tooltip from '@atlaskit/tooltip';
import messages from '../../../../common/utils/i18n/messages';
import { OpenInNewTabButtonContainer } from './styled';
export var OpenInNewTabButton = function OpenInNewTabButton(_ref) {
  var notificationUrl = _ref.notificationUrl,
    onClick = _ref.onClick;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: intl.formatMessage(messages.inboxOpenNotificationInNewTabTooltip)
  }, /*#__PURE__*/React.createElement(OpenInNewTabButtonContainer, {
    className: "notification-list__open-in-new-tab-button"
  }, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    target: "_blank",
    href: notificationUrl,
    iconBefore: /*#__PURE__*/React.createElement(ShortcutIcon, {
      label: ""
    }),
    "aria-label": intl.formatMessage(messages.inboxOpenNotificationInNewTabTooltip),
    onClick: onClick
  })));
};